import { Icon } from "@iconify/react";
import ReactAudioPlayer from "react-audio-player";
import { useNavigate } from "react-router-dom";

function StarRating(props) {
    const { advice } = props;
  
    const renderStars = () => {
      const stars = [];
      for (let i = 0; i < advice; i++) {
        stars.push(<Icon key={i} icon="material-symbols:star" />);
      }
      return stars;
    };
  
    return (
      <>
        {renderStars()}
      </>
    );
  }


function ProfileBar(props) {
    const navigate = useNavigate();
    const { benefits, expertId, officeName } = props;
    const isWebhook = props.isWebhook || window.location.pathname.includes('/webhook/');
    const baseUrl = window.location.origin;

    const handleNavigation = (path) => {
        if (isWebhook) {
            window.open(baseUrl + path, '_blank', 'noreferrer');
        } else {
            navigate(path);
        }
    };

    return (
        <section id="profileBar" className="modern-profile-bar">
            <div className="profile-avatar" style={{ 
                        backgroundImage: `url("`+ props.imageProfile +`")` 
                    }}></div>
            <div className="profile-info">
                <div className="profile-details">
                    <div className="profile-main">
                        <h3 className="profile-name">{props.name}</h3>
                        {props.voice ?  <ReactAudioPlayer
                            src={props.voice}
                            title={"Audio"}
                            controls
                            className="audio-player"
                        /> : ""}
                    </div>
                    <div className="profile-stats">
                        <span className="stat-item">{props.advice} avis</span>
                        <div className="stars">
                            <StarRating advice={props.scores} />
                        </div>
                        <span className="stat-item">{props.callCount} consultations</span>
                    </div>
                </div>
                <div className="profile-nav">
                    {benefits && benefits.includes("CHAT") && (
                        <button className="nav-item consultation-btn">
                            <Icon icon="material-symbols:chat" />
                            <span>Discuter en ligne</span>
                        </button>
                    )}
                    {benefits && benefits.includes("MAIL") && (
                        <button 
                            className="nav-item consultation-btn"
                            onClick={() => {
                                const path = "/" + officeName + "/client/payment-email/" + expertId;
                                if (isWebhook) {
                                    window.open(baseUrl + path, "_blank", 'noreferrer');
                                } else {
                                    window.open(path, "_blank");
                                }
                            }}
                        >
                            <Icon icon="material-symbols:mail" />
                            <span>Consultation par mail</span>
                        </button>
                    )}
                    {benefits && benefits.includes("MEET") && (
                        <button 
                            className="nav-item consultation-btn"
                            onClick={() => {
                                const path = "/" + officeName + "/client/payment-rdv/" + expertId;
                                if (isWebhook) {
                                    window.open(baseUrl + path, "_blank", 'noreferrer');
                                } else {
                                    window.open(path, "_blank");
                                }
                            }}
                        >
                            <Icon icon="fa6-solid:calendar-days" />
                            <span>Planifier un rendez-vous</span>
                        </button>
                    )}
                    {benefits && benefits.includes("CALL") && (
                        <button 
                            className="nav-item consultation-btn"
                            onClick={() => {
                                const path = "/" + officeName + "/client/expertList/" + expertId + "/call";
                                if (isWebhook) {
                                    window.open(baseUrl + path, "_blank", 'noreferrer');
                                } else {
                                    handleNavigation(path);
                                }
                            }}
                        >
                            <Icon icon="ic:outline-access-time-filled" />
                            <span>Démarrer un appel</span>
                        </button>
                    )}
                </div>
            </div>
        </section>
    );
}

export default ProfileBar;